const t={learner:"learn",author:"stem",authorReact:"teach",scorm:"scorm",templateEditor:"template-editor"};export{t as ROUTE_BASE};
//# sourceMappingURL=routeBase.js.map
